import React, { Component } from "react";
import Product from "./Product";
import AliceCarousel from "react-alice-carousel";

export class PopularProducts extends Component {
  render() {
    const {
      title,
      products,
      linkTitle,
      link,
      subtitle,
      showSubtitle,
      priceFrom,
      productPurchaseLinkText,
      productDetailsLinkText,
      defaultLink,
      defaultLinkText,
    } = this.props.config;
    const items = products.map((product) => {
      return (
        <Product
          product={product}
          priceFrom={priceFrom}
          productPurchaseLinkText={productPurchaseLinkText}
          productDetailsLinkText={productDetailsLinkText}
        />
      );
    });
    const responsive = {
      0: {
        items: 1,
      },
      641: {
        items: 2,
        itemsFit: "contain",
      },
    };
    return (
      <div className="container container--center container--margin">
        <h3 className="popular-products__widget-title">{title}</h3>
        {showSubtitle && <p>{subtitle}</p>}
        <div className="mobile-only">
          <AliceCarousel
            mouseTrackingEnabled={true}
            items={items}
            responsive={responsive}
            disableButtonsControls={true}
          />
        </div>
        <div className="grid mobile-hide popular-products__centered_cards">
          {items}
        </div>
        <div className="popular-products__center-link">
          {link ? (
            <a href={link.Url} title={link.Alt} target={link.Target}>
              {linkTitle === "" ? defaultLinkText : linkTitle}
            </a>
          ) : (
            <a href={defaultLink}>
              {linkTitle === "" ? defaultLinkText : linkTitle}
            </a>
          )}
        </div>
      </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Products/PopularProducts.js